module.exports = __webpack_public_path__ + "img/hn.7e936f52.svg";